import { Extension } from "@tiptap/core";

export const ResponsiveClass = Extension.create({
	name: "responsiveClass",

	addGlobalAttributes() {
		return [
			{
				types: ["paragraph", "heading"],
				attributes: {
					responsiveClasses: {
						default: null,
						parseHTML: (element) => {
							if (element.className) {
								const classList = element.className.split(" ");
								// Extract responsive text classes (sm:, md:, lg:, xl:)
								const responsiveTextClasses = classList.filter(
									(cls) =>
										/^(xs|sm|md|lg|xl|2xl):text-/.test(cls),
								);
								return responsiveTextClasses.length > 0
									? responsiveTextClasses.join(" ")
									: null;
							}
							return null;
						},
						renderHTML: (attributes) => {
							if (!attributes.responsiveClasses) return {};
							return {
								class: attributes.responsiveClasses,
							};
						},
					},
				},
			},
		];
	},
});
